// Official ClothedEye Sticker Colors
// These are the exact colors used in the sticker production
// DO NOT MODIFY without explicit approval

export const COLORS = [
  { name: 'Black (Matte)', hex: '#000000', index: 0 },
  { name: 'White (Matte)', hex: '#FFFFFF', index: 1 },
  { name: 'Gray', hex: '#808080', index: 2 },
  { name: 'Red', hex: '#FF0000', index: 3 },
  { name: 'Orange', hex: '#FFA500', index: 4 },
  { name: 'Yellow', hex: '#FFFF00', index: 5 },
  { name: 'Dozer Yellow', hex: '#FFD700', index: 6 },
  { name: 'Green', hex: '#008000', index: 7 },
  { name: 'Forest Green', hex: '#228B22', index: 8 },
  { name: 'Ice Blue', hex: '#87CEEB', index: 9 },
  { name: 'Sky Blue', hex: '#87CEEB', index: 10 },
  { name: 'Blue', hex: '#0000FF', index: 11 },
  { name: 'Purple', hex: '#800080', index: 12 },
  { name: 'Violet', hex: '#8A2BE2', index: 13 },
  { name: 'Pink', hex: '#FFC0CB', index: 14 },
  { name: 'Silver Metallic', hex: '#C0C0C0', index: 15 },
  { name: 'Gold Metallic', hex: '#FFD700', index: 16 },
  { name: 'Copper Metallic', hex: '#B87333', index: 17 },
  { name: 'Gray Holographic', hex: '#808080', index: 18 },
  { name: 'Nut Brown', hex: '#8B4513', index: 19 },
  { name: 'Brown', hex: '#A52A2A', index: 20 }
];

// Get color by name
export const getColorByName = (name) => {
  return COLORS.find(color => color.name === name);
};

// Get color by index
export const getColorByIndex = (index) => {
  return COLORS[index];
};

// Get all color names
export const getColorNames = () => {
  return COLORS.map(color => color.name);
};

// Color names array for direct access
export const COLOR_NAMES = COLORS.map(color => color.name);

// Official ClothedEye color filters by index (0-20) - PRODUCTION READY
export const COLOR_FILTERS_BY_INDEX = [
  "brightness(0) saturate(100%)", // 0 - Black (Matte)
  "brightness(0) saturate(100%) invert(100%)", // 1 - White (Matte)
  "brightness(0) saturate(100%) invert(50%)", // 2 - Gray
  "brightness(0) saturate(100%) invert(21%) sepia(100%) saturate(4932%) hue-rotate(345deg) brightness(0.7)", // 3 - Red
  "brightness(0) saturate(100%) invert(68%) sepia(67%) saturate(6494%) hue-rotate(13deg) brightness(0.9)", // 4 - Orange
  "brightness(0) saturate(100%) invert(89%) sepia(73%) saturate(1572%) hue-rotate(359deg) brightness(1.1)", // 5 - Yellow
  "brightness(0) saturate(100%) invert(75%) sepia(100%) saturate(3000%) hue-rotate(-10deg) brightness(1.0)", // 6 - Dozer Yellow
  "brightness(0) saturate(100%) invert(64%) sepia(26%) saturate(1351%) hue-rotate(78deg) brightness(0.9)", // 7 - Green
  "brightness(0) saturate(100%) invert(22%) sepia(64%) saturate(1351%) hue-rotate(125deg) brightness(0.6)", // 8 - Forest Green
  "brightness(0) saturate(100%) invert(60%) sepia(94%) saturate(1351%) hue-rotate(174deg) brightness(1.0)", // 9 - Ice Blue
  "brightness(0) saturate(100%) invert(44%) sepia(99%) saturate(1351%) hue-rotate(187deg) brightness(0.9)", // 10 - Sky Blue
  "brightness(0) saturate(100%) invert(19%) sepia(86%) saturate(1351%) hue-rotate(217deg) brightness(0.7)", // 11 - Blue
  "brightness(0) saturate(100%) invert(20%) sepia(74%) saturate(1351%) hue-rotate(251deg) brightness(0.6)", // 12 - Purple
  "brightness(0) saturate(100%) invert(25%) sepia(84%) saturate(1351%) hue-rotate(284deg) brightness(0.7)", // 13 - Violet
  "brightness(0) saturate(100%) invert(65%) sepia(94%) saturate(1351%) hue-rotate(316deg) brightness(1.1)", // 14 - Pink
  "brightness(0) saturate(100%) invert(70%) sepia(0%) saturate(0%) contrast(120%)", // 15 - Silver Metallic
  "brightness(0) saturate(100%) invert(88%) sepia(100%) saturate(1500%) hue-rotate(2deg) brightness(1.0)", // 16 - Gold Metallic
  "brightness(0) saturate(100%) invert(60%) sepia(100%) saturate(1000%) hue-rotate(15deg)", // 17 - Copper Metallic
  "brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) contrast(130%)", // 18 - Gray Holographic
  "brightness(0) saturate(100%) invert(44%) sepia(65%) saturate(1351%) hue-rotate(13deg) brightness(0.8)", // 19 - Nut Brown
  "brightness(0) saturate(100%) invert(20%) sepia(65%) saturate(1351%) hue-rotate(13deg) brightness(0.5)" // 20 - Brown
];

// Get color filter by index (0-20) - MAIN FILTER FUNCTION
export const getColorFilter = (colorIndex) => {
  return COLOR_FILTERS_BY_INDEX[colorIndex] || COLOR_FILTERS_BY_INDEX[0]; // Default to black
};

// Legacy support - COLOR_FILTERS object for name-based access
export const COLOR_FILTERS = {};
COLORS.forEach((color, index) => {
  COLOR_FILTERS[color.name] = COLOR_FILTERS_BY_INDEX[index];
});

// Add short name mappings for compatibility with abbreviated names from Etsy data
COLOR_FILTERS['Black'] = COLOR_FILTERS_BY_INDEX[0];
COLOR_FILTERS['White'] = COLOR_FILTERS_BY_INDEX[1];
COLOR_FILTERS['Gray'] = COLOR_FILTERS_BY_INDEX[2];
COLOR_FILTERS['Red'] = COLOR_FILTERS_BY_INDEX[3];
COLOR_FILTERS['Orange'] = COLOR_FILTERS_BY_INDEX[4];
COLOR_FILTERS['Yellow'] = COLOR_FILTERS_BY_INDEX[5];
COLOR_FILTERS['Dozer Yellow'] = COLOR_FILTERS_BY_INDEX[6];
COLOR_FILTERS['Green'] = COLOR_FILTERS_BY_INDEX[7];
COLOR_FILTERS['Forest Green'] = COLOR_FILTERS_BY_INDEX[8];
COLOR_FILTERS['Ice Blue'] = COLOR_FILTERS_BY_INDEX[9];
COLOR_FILTERS['Sky Blue'] = COLOR_FILTERS_BY_INDEX[10];
COLOR_FILTERS['Blue'] = COLOR_FILTERS_BY_INDEX[11];
COLOR_FILTERS['Purple'] = COLOR_FILTERS_BY_INDEX[12];
COLOR_FILTERS['Violet'] = COLOR_FILTERS_BY_INDEX[13];
COLOR_FILTERS['Pink'] = COLOR_FILTERS_BY_INDEX[14];
COLOR_FILTERS['Silver'] = COLOR_FILTERS_BY_INDEX[15]; // Silver Metallic
COLOR_FILTERS['Gold'] = COLOR_FILTERS_BY_INDEX[16];   // Gold Metallic
COLOR_FILTERS['Copper'] = COLOR_FILTERS_BY_INDEX[17]; // Copper Metallic
COLOR_FILTERS['Gray Holographic'] = COLOR_FILTERS_BY_INDEX[18];
COLOR_FILTERS['Nut Brown'] = COLOR_FILTERS_BY_INDEX[19];
COLOR_FILTERS['Brown'] = COLOR_FILTERS_BY_INDEX[20];

// Hero area excluded colors (indices 1, 5, 6, 14, 16)
export const HERO_EXCLUDED_COLORS = [1, 5, 6, 14, 16];

// Get colors for hero area (excluding specific colors)
export const getHeroColors = () => {
  return COLORS.filter(color => !HERO_EXCLUDED_COLORS.includes(color.index));
};

// Additional exports for compatibility with main branch
export const AVAILABLE_COLORS = COLOR_NAMES;

// Color hex values for UI display
export const COLOR_HEX = {};
COLORS.forEach(color => {
  COLOR_HEX[color.name] = color.hex;
});

export default COLORS; 